import i18n from '../i18n';

/**
 * enumLabel — mapping d'AFFICHAGE générique des enums (vague i18n 1.8a/1.8b).
 *
 * Le code/chaîne stocké en DB reste INCHANGÉ ; seul l'affichage est traduit
 * via `<namespace>.<field>.<value>`. La `value` soumise au backend par les
 * <select> ne passe jamais par ce helper.
 *
 * `namespace` porte le segment `.enums` quand il existe (ex. 'horses.enums',
 * 'health.enums') ; pour les enums « plats » on passe le préfixe direct
 * (ex. 'alerts' + field 'param' → `alerts.param.<value>`).
 *
 * @param {string} namespace - préfixe i18n (ex. 'horses.enums', 'health.enums', 'alerts')
 * @param {string} field     - clé d'enum (ex. 'type', 'category', 'param', 'method')
 * @param {string|number} value - code/chaîne DB (ex. 'cheval', 'Vermifuge', 'pm25', 1)
 * @param {Function} [t]      - fonction t du hook useTranslation ; à défaut, i18n singleton
 * @returns {string} libellé traduit, ou la valeur brute si la clé manque
 *                   (valeur legacy/hors-liste → pas de clé affichée).
 */
export function enumLabel(namespace, field, value, t) {
  if (value == null || value === '') return value;
  const key = `${namespace}.${field}.${value}`;
  // defaultValue = filet de sécurité : valeur DB inconnue/legacy → valeur brute.
  return t ? t(key, { defaultValue: value }) : i18n.t(key, { defaultValue: value });
}
